/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_TitleInputs */

const vi_tea_grade_title = /** @type {(inputs: Tea_Grade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại phân loại`)
};

/**

* @param {Tea_Grade_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_title = /** @type {((inputs?: Tea_Grade_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_title(inputs)
});